export enum DebugGeography {
  /**
   * Debug geography disabled.
   */
  DISABLED = 0,

  /**
   * Geography appears as in EEA for debug devices.
   */
  EEA = 1,

  /**
   * Geography appears as not in EEA for debug devices.
   */
  NOT_EEA = 2,
}
